<template>
  <div class="home_box">
    <HomeHeader />
    <div style="height: 70px;"></div>
    <div class="main_body">
      <router-view @search-mode-change="smartSearchActive = $event"></router-view>
    </div>
    <footerInfo v-show="!smartSearchActive" class="home-footer" />
  </div>
</template>

<script>
import HomeHeader from '@/pages/newPages/booking/components/HomeHeader'
import footerInfo from '../frame/footerInfo.vue';
export default {
  data () {
    return {
      smartSearchActive: false
    }
  },
  components: {
    HomeHeader,
    footerInfo
  },
  methods: {},
}
</script>

<style lang="less" scoped>
.home_box {
  padding: 0;
  margin: 0;
  min-height: 100vh;
  width: 100%;
}

.main_body {
  width: 100%;
}

.home-footer {
  position: relative;
  z-index: 1;
  background-color: #fff;
}
</style>

<style>
/* Reserve the page scrollbar even when a search mode has less content. */
html { overflow-y: scroll; }
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/home.vue